import StandardRestError from './Standard'

class FolderNotEmptyError extends StandardRestError {
  static CODE = 'FOLDER_NOT_EMPTY'

  code: string

  constructor(
    message = 'Folder must be empty before deletion.',
    status = 409,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
    this.code = FolderNotEmptyError.CODE
  }
}

export default FolderNotEmptyError
